import React from 'react';
import UploadIcon from '@atlaskit/icon/glyph/upload';
import type { UIAnalyticsEvent, Attributes } from '@atlassian/jira-product-analytics-bridge';
import { ResponsiveLinkButton } from '@atlassian/jira-responsive-button';
import { IMPORT_BUTTON_TEST_ID } from '../../../common/constants';
import { ImportWorkButtonViewed } from '../../../common/ui/import-work-button-viewed';

type Props = {
	label: string;
	onClick: (e: React.MouseEvent<HTMLElement, MouseEvent>, analyticsEvent: UIAnalyticsEvent) => void;
	attributes: Attributes;
};

export const ImportLink = ({ label, onClick, attributes }: Props) => (
	<>
		<ImportWorkButtonViewed attributes={attributes} />
		<ResponsiveLinkButton
			icon={UploadIcon}
			testId={IMPORT_BUTTON_TEST_ID}
			label={label}
			href="/secure/admin/ExternalImport1.jspa"
			target="_blank"
			onClick={onClick}
		/>
	</>
);
